import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./carousel.css";

function SliderComponent({ images }) {
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
  };

  // Create an array to track which images have been loaded
  const [loadedImages, setLoadedImages] = useState(Array(images.low.length).fill(false));

  // Handle image load for each specific image
  const handleImageLoad = (index) => {
    const newLoadedImages = [...loadedImages];
    newLoadedImages[index] = true; // Mark the image as loaded
    setLoadedImages(newLoadedImages);
  };
  console.log(images)

  return (
    <div style={{ width: "-webkit-fill-available" }}>
      <Slider
        {...settings}
        style={{ width: "100%", height: "fit-content", overflow: "visible" }}
      >
        {images.low.map((image, index) => (
          <div key={index} className="img">
            <img
              src={loadedImages[index] ? images.high[index] : images.low[index]} // Switch to high quality if loaded
              alt={`Slide ${index + 1}`}
              loading="lazy"
              className={`product-image ${loadedImages[index] ? "loaded" : "loading"}`}
              onLoad={() => handleImageLoad(index)} // Handle load for this image
            />
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default SliderComponent;
